// Clear any service workers and caches on app load
// This helps prevent stale cache issues

export const clearStaleCache = async () => {
  // Clear service workers if any exist
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
  }

  // Clear all caches
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map((cacheName) => caches.delete(cacheName))
    );
  }
};

// Auto-reload on chunk load error
export const setupChunkErrorHandler = () => {
  window.addEventListener('error', (event) => {
    // Check if this is a chunk loading error
    if (
      event.message.includes('Loading chunk') ||
      event.message.includes('page resources') ||
      event.message.includes('Failed to fetch dynamically imported module')
    ) {
      console.warn('Chunk loading error detected, reloading page...');
      
      // Prevent infinite reload loop
      const reloadCount = Number(sessionStorage.getItem('chunkErrorReloadCount') || '0');
      
      if (reloadCount < 3) {
        sessionStorage.setItem('chunkErrorReloadCount', String(reloadCount + 1));
        window.location.reload();
      } else {
        console.error('Multiple chunk load failures detected. Please clear your browser cache and try again.');
        sessionStorage.removeItem('chunkErrorReloadCount');
      }
    }
  });

  // Reset reload count on successful load
  window.addEventListener('load', () => {
    sessionStorage.removeItem('chunkErrorReloadCount');
  });
};
